import axios from "axios";
import { message } from "antd";
const BASE_URL = process.env.REACT_APP_API_URL ;


const api = axios.create({
  baseURL:BASE_URL ,
});

export const setupInterceptors = (setLoading) => {
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }else {
        // Remove all data from local storage if no token exists
        localStorage.clear();
      }
      setLoading && setLoading(true);
      return config;
    },
    (error) => {
      setLoading && setLoading(false);
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      setLoading && setLoading(false);
      return response;
    },
    (error) => {
      setLoading && setLoading(false);
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400:
            message.error(data.message || data);
            break;
          case 401:
            message.error("Unauthorized! Please log in again.");
            localStorage.clear();
            window.location.href = "/login";
            break;
          case 404:
            message.error("Requested resource not found.");
            break;
          case 500:
            message.error("Server Error! Please try again later.");
            break;
          default:
            message.error(data.message || "An error occurred. Please try again.");
        }
      } else {
        message.error("Network Error! Please check your internet connection.");
      }
      return Promise.reject(error);
    }
  );
};

export default api;
